export default {
  //hostname: "http://localhost:5003",
  hostname: "https://test1.e-attendance.com",
};
